/**
 * Die Geometrie des Balkens „Dein Strom vom Haus" (HM-166, Entwurf 3s/3q in
 * `ui_kits/dashboard/Kennzahlen Bewohner Varianten.html`). Gerechnet hat der
 * Server (`pvAvailability`); hier wird nur bestimmt, wo was im Balken steht.
 *
 * Die Skala ist das Größere aus Verfügbarem und Verbrauch: Reicht der
 * PV-Strom, ist der Balken das Verfügbare und füllt sich mit dem Verbrauch;
 * reicht er nicht, ist er der Verbrauch, und hinter dem Strich wird es orange.
 */
import type { ApiComponents } from "@hausmeter/sdk";

export type PvAvailability = NonNullable<
  ApiComponents["schemas"]["UnitLiveAllocation"]["pvAvailability"]
>;

export interface AvailabilityBar {
  /** Der Strich: das Verfügbare, 0…1 der Skala. */
  readonly marker: number;
  /** Grün: der gedeckte Verbrauch. */
  readonly covered: number;
  /** Orange hinter dem Strich: was aus dem Netz kommt. */
  readonly fromGrid: number;
}

export function availabilityBar(
  value: PvAvailability,
  consumptionW: number,
): AvailabilityBar | null {
  const scale = Math.max(value.availableW, consumptionW);
  if (value.state === "no_sun" || scale <= 0) return null;
  const marker = value.availableW / scale;
  const covered = Math.min(consumptionW, value.availableW) / scale;
  return { marker, covered, fromGrid: value.fromGridW / scale };
}
